import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';

const { FiStar, FiMessageSquare } = FiIcons;

const Testimonial = () => {
  return (
    <section className="py-24 md:py-28 bg-white">
      <div className="max-w-4xl mx-auto px-6 md:px-12 text-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-[#8cc63f]/10 mb-6">
            <FiMessageSquare className="text-[#8cc63f] text-2xl" />
          </div>
          <div className="flex justify-center gap-1 mb-6">
            {[...Array(5)].map((_, i) => (
              <FiStar key={i} className="text-yellow-400 fill-yellow-400 text-xl" />
            ))}
          </div>
          <blockquote className="text-2xl md:text-3xl font-semibold text-[#4b4b4b] leading-relaxed mb-8 italic">
            "Get Cleaning Clicks has been doing our SEO for over 3 years. We are currently growing at{' '}
            <span className="text-[#8cc63f] not-italic font-black">4% per month</span> from Google Search."
          </blockquote>
          <div className="flex items-center justify-center gap-4">
            <img
              src="/images/avatar-2.webp"
              alt="Paul Fried"
              className="w-14 h-14 rounded-full object-cover border-2 border-[#8cc63f]/30"
            />
            <div className="text-left">
              <p className="font-bold text-[#4b4b4b]">Paul Fried</p>
              <p className="text-gray-500 text-sm">Maid Service in Hoboken, NJ</p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Testimonial;